/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type AddModelCatalogOrgAccessRequest = {
  orgId: string;
  accessMutationRequest: components.AccessMutationRequest;
};

/** @internal */
export const AddModelCatalogOrgAccessRequest$inboundSchema: z.ZodType<
  AddModelCatalogOrgAccessRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  orgId: z.string(),
  AccessMutationRequest: components.AccessMutationRequest$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "AccessMutationRequest": "accessMutationRequest",
  });
});
/** @internal */
export type AddModelCatalogOrgAccessRequest$Outbound = {
  orgId: string;
  AccessMutationRequest: components.AccessMutationRequest$Outbound;
};

/** @internal */
export const AddModelCatalogOrgAccessRequest$outboundSchema: z.ZodType<
  AddModelCatalogOrgAccessRequest$Outbound,
  z.ZodTypeDef,
  AddModelCatalogOrgAccessRequest
> = z.object({
  orgId: z.string(),
  accessMutationRequest: components.AccessMutationRequest$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    accessMutationRequest: "AccessMutationRequest",
  });
});

export function addModelCatalogOrgAccessRequestToJSON(
  addModelCatalogOrgAccessRequest: AddModelCatalogOrgAccessRequest,
): string {
  return JSON.stringify(
    AddModelCatalogOrgAccessRequest$outboundSchema.parse(
      addModelCatalogOrgAccessRequest,
    ),
  );
}
export function addModelCatalogOrgAccessRequestFromJSON(
  jsonString: string,
): SafeParseResult<AddModelCatalogOrgAccessRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AddModelCatalogOrgAccessRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AddModelCatalogOrgAccessRequest' from JSON`,
  );
}
